import React from 'react'
import { postDownloadDocuments } from 'lib/PDSApi'
import { Button } from 'react-bootstrap'

interface DocumentButtonProps {
  documentIds: number[]
}

export const DownloadDocumentsButton = ({
  documentIds,
}: DocumentButtonProps) => {
  const downloadDocuments = async () => {
    postDownloadDocuments(documentIds)
  }

  const disabled = !(documentIds.length > 0)

  return (
    <Button
      className="btn-icon-download"
      variant="primary"
      onClick={downloadDocuments}
      disabled={disabled}
      block>
      Download Selected
    </Button>
  )
}
